export type SunnyBotMessage = {
  key: string;
  titleDesktop?: string,
  titleMobile?: string,
  message?: string;
};

const sunnyBotMessages: SunnyBotMessage[] = [
  {
    key: 'property',
    titleDesktop: 'Hey! I’m Sunny the solar bot.',
    titleMobile: 'Hey! I’m Sunny the solar bot.',
    message: 'I’ll get you a solar estimate in seconds.',
  },
  {
    key: 'sunlight',
  },
  {
    key: 'addressOwnership',
  },
  {
    key: 'bill',
  },
  {
    key: 'provider',
  },
  {
    key: 'emailLink',
  },
  {
    key: 'contact',
  },
  {
    key: 'have_solar',
    message: ' Just a couple more questions, to see if you qualify for additional incentives.',
  },
  {
    key: 'timeline',
    message: ' Just a couple more questions, while I customize your estimate.',
  },
  {
    key: 'local_installer',
    message: ' Just a couple more questions, while I customize your estimate.',
  },
  {
    key: 'answer_phone',
    message: ' Just a couple more questions, while I customize your estimate.',
  },
  {
    key: 'credit',
    message: ' Just a couple more questions, while I customize your estimate.',
  },
  {
    key: 'otp_verify',
    message:
      'Due to extremely high demand I need to confirm you are a real person.',
  },
];

export default sunnyBotMessages;
